import { CircularProgressbar } from "react-circular-progressbar"
import AudioPlayer from "../components/ChatAdudioPlayer"
import ChatUserItemComp from "../components/ChatUserItemComp"
import { UserChatItem } from "../models/api/UserChatItem"
import 'react-circular-progressbar/dist/styles.css';
import { LandingMain } from "../static/LandingMain";

const chatItem:UserChatItem = {
    chatId: '4545',
    recepUserId: 'abc',
    lastChatTime: 12,
    lastChatMsg: {
        msg: 'Hi',
        msgId: 'ddsadd',
        senderUid: 'ddsadadadw',
        senderUserId: 'dasert',
        time: 1256524542,
        voice: 'tryueu',
    }
}

const Demo = () => {

    return (
        <LandingMain/>
    )
} 

export default Demo